import fy2Api from '@/api/fy2Api';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_CHANNELS_ALL_CHANNEL, LOAD_CHANNELS_ROOT, SEO } from '../protocols';

export interface State {
    list: ChannelInfo[]
}

class ChannelsAllChannel extends BaseModule<State> {
    constructor() {
        super(LOAD_CHANNELS_ALL_CHANNEL[0])
    }

    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                list: [],
            },
            actions: {
                async loadData({ state, dispatch }, route: Route) {
                    state.list = await fy2Api.getAllChannels()
                },
                [LOAD_CHANNELS_ALL_CHANNEL[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch(LOAD_CHANNELS_ROOT[0] + '/loadLeft', {}, { root: true }),
                        dispatch('loadData', route),
                    ])
                }
            }
        }
    }
}

export default new ChannelsAllChannel()